var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{on:{"resize":function($event){return _vm.resizeIframe()}}},[_c('iframe',{staticStyle:{"height":"100vh","border":"none"},attrs:{"id":"training-iframe","width":"100%","src":"./hcpTraining.html","frameborder":"0","scrolling":"no"},on:{"load":function($event){return _vm.iframeLoaded()}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }